import { observer } from 'mobx-react'
import { useMemo } from 'react'
import  orderBy  from 'lodash/orderBy'

import { CheckboxBasedFilter, OptionsProps } from '@avantstay/backoffice-core'

import { ColumnFilterProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import { casesStore } from '@new/domains/operations/screens/CasesV2/stores/CasesStore'
import { CaseFilterIds } from '@new/domains/operations/screens/CasesV2/utils/config'
import { parseLabel } from '@new/domains/operations/utils/parseLabel'

import * as S from './commonFilterStyles.style'

const _StatusFilter = (props: ColumnFilterProps) => {
  const { caseInputs, isLoadingCaseInputs } = casesStore
  const { recordTypes, status, setFilterValue } = casesFiltersStore

  const handleDataFilter = (value?: string[] | undefined) => {
    setFilterValue(CaseFilterIds.Status, value)
  }

  const options = useMemo(() => {
    if (!caseInputs) return []

    const computedOptions = Object.entries(caseInputs).reduce<OptionsProps<string>[]>(
      (acc, [recordType, caseInput]) => {
        if (recordTypes && !recordTypes.includes(recordType)) return acc

        const groupName = parseLabel(recordType)
        const listByRecordType =
          caseInput.statuses?.map(status => ({
            label: parseLabel(status.label),
            value: status.apiName,
            group: groupName,
            hasFullWidth: true,
          })) ?? []
        return [...acc, ...listByRecordType]
      },
      [],
    )
    return orderBy(computedOptions, ['group', 'label'])
  }, [caseInputs, recordTypes])

  return (
    <S.CheckBoxWrapper optionsLength={options.length}>
      <CheckboxBasedFilter
        shouldGroupBy
        isLoadingOptions={isLoadingCaseInputs}
        title="Status"
        options={options}
        initialValue={status}
        onChange={handleDataFilter}
        {...props}
      />
    </S.CheckBoxWrapper>
  )
}

export const StatusFilter = observer(_StatusFilter)
